/*
 前端路由配置文件
 vue-router文档: http://router.vuejs.org/zh-cn/
*/

import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ '../pages/home')
const supplier = () => import(/* webpackChunkName: "supplier" */ '../pages/supplier')
const purchase = () => import(/* webpackChunkName: "purchase" */ '../pages/purchase')
const returnedPurchase = () => import(/* webpackChunkName: "returnedPurchase" */ '../pages/returned-purchase')
const transfer = () => import(/* webpackChunkName: "transfer" */ '../pages/transfer')
const inventory = () => import(/* webpackChunkName: "inventory" */ '../pages/inventory')
const instock = () => import(/* webpackChunkName: "instock" */ '../pages/instock')
const contact = () => import(/* webpackChunkName: "contact" */ '../pages/contact')
const outstock = () => import(/* webpackChunkName: "outstock" */ '../pages/outstock')
const productStock = () => import(/* webpackChunkName: "productStock" */ '../pages/product-stock')
const customer = resolve => require.ensure(['../pages/customer'], () => resolve(require('../pages/customer')), 'customer')
const customerNearby = resolve => require.ensure(['../pages/customer/nearby'], () => resolve(require('../pages/customer/nearby')), 'customerNearby')
const opportunity = resolve => require.ensure(['../pages/opportunity'], () => resolve(require('../pages/opportunity')), 'opportunity')
const contract = resolve => require.ensure(['../pages/contract'], () => resolve(require('../pages/contract')), 'contract')
const payPlan = resolve => require.ensure(['../pages/pay-plan'], () => resolve(require('../pages/pay-plan')), 'payPlan')
const payment = resolve => require.ensure(['../pages/pay-ment'], () => resolve(require('../pages/pay-ment')), 'payment')
const communicate = resolve => require.ensure(['../pages/communicate'], () => resolve(require('../pages/communicate')), 'communicate')
const communicatePlan = resolve => require.ensure(['../pages/communicate-plan'], () => resolve(require('../pages/communicate-plan')), 'communicatePlan')
const workReport = resolve => require.ensure(['../pages/work-report'], () => resolve(require('../pages/work-report')), 'workReport')
const workStatistical = resolve => require.ensure(['../pages/work-report/statistical'], () => resolve(require('../pages/work-report/statistical')), 'workStatistical')
const workSetup = resolve => require.ensure(['../pages/work-report/setup'], () => resolve(require('../pages/work-report/setup')), 'workSetup')
const strategySetup = () => import(/* webpackChunkName: "strategySetup" */ '../pages/strategy/setup')
const targetCustomer = () => import(/* webpackChunkName: "targetCustomer" */ '../pages/target-through/customer')
const targetOpportunity = () => import(/* webpackChunkName: "targetOpportunity" */ '../pages/target-through/opportunity')
const targetContract = () => import(/* webpackChunkName: "targetContract" */ '../pages/target-through/contract')
const targetCommunicate = () => import(/* webpackChunkName: "targetCommunicate" */ '../pages/target-through/communicate')
const targetProductContract = () => import(/* webpackChunkName: "targetProductContract" */ '../pages/target-through/product-contract')
const targetContact = () => import(/* webpackChunkName: "targetContact" */ '../pages/target-through/contact')
const targetPaymentUn = () => import(/* webpackChunkName: "targetPaymentUn" */ '../pages/target-through/payment-un')
const targetPaymentEd = () => import(/* webpackChunkName: "targetPaymentEd" */ '../pages/target-through/payment-ed')
const targetPayPlanUn = () => import(/* webpackChunkName: "targetPayPlanUn" */ '../pages/target-through/pay-plan-un')
const targetPayPlanEd = () => import(/* webpackChunkName: "targetPayPlanEd" */ '../pages/target-through/pay-plan-ed')
const targetPurchase = () => import(/* webpackChunkName: "targetPurchase" */ '../pages/target-through/purchase')
const targetInvoiceEd = () => import(/* webpackChunkName: "targetInvoiceEd" */ '../pages/target-through/invoice-ed')
const targetRefund = () => import(/* webpackChunkName: "targetRefund" */ '../pages/target-through/refund')
const targetWorkOrder = () => import(/* webpackChunkName: "targetWorkOrder" */ '../pages/target-through/workorder')
const targetWorkflow4Order = () => import(/* webpackChunkName: "targetWorkflow4Order" */ '../pages/target-through/workflow4-order')
const targetWorkflow4Degree = () => import(/* webpackChunkName: "targetWorkflow4Degree" */ '../pages/target-through/workflow4-degree')
const targetProductionOrder = () => import(/* webpackChunkName: "targetProductionOrder" */ '../pages/target-through/production-order')
const messagePage = resolve => require.ensure(['../pages/message/message-page'], () => resolve(require('../pages/message/message-page')), 'messagePage')
const messageStatistical = resolve => require.ensure(['../pages/message/statistical'], () => resolve(require('../pages/message/statistical')), 'messageStatistical')

/* --业绩目标开始-- */
const managementByObjective = resolve => require.ensure(['../pages/performance-objective'], () => resolve(require('../pages/performance-objective')), 'performanceObjective')
const performanceObjectiveIndexSetting = resolve => require.ensure(['../pages/performance-objective/performance-objective-index-setting'], () => resolve(require('../pages/performance-objective/performance-objective-index-setting')), 'PerformanceObjectiveIndexSetting')
const performanceObjectiveValueSetting = resolve => require.ensure(['../pages/performance-objective/performance-objective-value-setting'], () => resolve(require('../pages/performance-objective/performance-objective-value-setting')), 'performanceObjectiveValueSetting')
const performanceObjectiveParamSetting = resolve => require.ensure(['../pages/performance-objective/performance-objective-param-setting'], () => resolve(require('../pages/performance-objective/performance-objective-param-setting')), 'performanceObjectiveParamSetting')
const performanceObjectiveImport = resolve => require.ensure(['../pages/performance-objective/performance-objective-import'], () => resolve(require('../pages/performance-objective/performance-objective-import')), 'performanceObjectiveImport')
/* -- 业绩目标结束 */

/* --  目标完成情况 */
const performanceCompletion = resolve => require.ensure(['../pages/performance-completion'], () => resolve(require('../pages/performance-completion')), 'performanceCompletion')
/* --  目标完成情况 */

const messagePushSet = resolve => require.ensure(['../pages/message/message-push-setting'], () => resolve(require('../pages/message/message-push-setting')), 'messagePushSet')
const signInManage = resolve => require.ensure(['../pages/sign-in-manage'], () => resolve(require('../pages/sign-in-manage')), 'signInManage')
const signInStatistic = resolve => require.ensure(['../pages/sign-in-statistic'], () => resolve(require('../pages/sign-in-statistic')), 'signInStatistic')
const biList = resolve => require.ensure(['../pages/bi/list'], () => resolve(require('../pages/bi/list')), 'biList')
const biSet = resolve => require.ensure(['../pages/bi/set'], () => resolve(require('../pages/bi/set')), 'biSet')
const biAdd = resolve => require.ensure(['../pages/bi/add-table'], () => resolve(require('../pages/bi/add-table')), 'biAdd')
import assemble from '../pages/assemble'
import invoice from '../pages/invoice'
const approvalSet = resolve => require.ensure(['../pages/approval-set'], () => resolve(require('../pages/approval-set')), 'approvalSet')
const approval = resolve => require.ensure(['../pages/approval'], () => resolve(require('../pages/approval')), 'approval')
const publicCustomerSetup = resolve => require.ensure(['../pages/public-customer/setup-new'], () => resolve(require('../pages/public-customer/setup-new')), 'publicCustomerSetup')
const publicRuleSetup = resolve => require.ensure(['../pages/public-customer/public-rule'], () => resolve(require('../pages/public-customer/public-rule')), 'publicRuleSetup')
const salesReport = resolve => require.ensure(['../pages/sales-report'], () => resolve(require('../pages/sales-report')), 'salesReport')
const jxcAddPage = () => import(/* webpackChunkName: "jxcAddPage" */ '../pages/product/jxc-add-page')
const productList = () => import(/* webpackChunkName: "productList" */ '../pages/product/product-list')
const wForPurchase = () => import(/* webpackChunkName: "wForPurchase" */ '../pages/w-for-purchase')
const waitInstock = () => import(/* webpackChunkName: "waitInstock" */ '../pages/wait-instock')
const waitOutstock = () => import(/* webpackChunkName: "waitOutstock" */ '../pages/wait-outstock')
const waitProduce = () => import(/* webpackChunkName: "waitProduce" */ '../pages/production-order/wait-produce')
const workOrder = resolve => require.ensure(['../pages/work-order'], () => resolve(require('../pages/work-order')), 'workOrder')
const workOrderManager = resolve => require.ensure(['../pages/work-order/manager-index'], () => resolve(require('../pages/work-order/manager-index')), 'workOrderManager')
const workOrderPendingOrder = resolve => require.ensure(['../pages/work-order/pending-order'], () => resolve(require('../pages/work-order/pending-order')), 'workOrderPendingOrder')
const serviceStaff = resolve => require.ensure(['../pages/work-order/service-staff'], () => resolve(require('../pages/work-order/service-staff')), 'serviceStaff')
const Agent = resolve => require.ensure(['../pages/call-center/agent'], () => resolve(require('../pages/call-center/agent')), 'agent')
const CallLog = resolve => require.ensure(['../pages/call-center/call-log'], () => resolve(require('../pages/call-center/call-log')), 'callLog')
const Setting = () => import(/* webpackChunkName: "setting" */ '../pages/call-center/setting')
const Teamdata = () => import(/* webpackChunkName: "teamdata" */ '../pages/call-center/teamdata')
const Print = () => import(/* webpackChunkName: "Print" */ '../pages/print/print-index')

/* --------模块设置模块----------- */
const application = () => import(/* webpackChunkName: "application" */ '../pages/application') // 模块设置首页
const applicationList = resolve => require.ensure(['../pages/application/list'], () => resolve(require('../pages/application/list')), 'applicationList') // 应用列表
const applicationDetail = resolve => require.ensure(['../pages/application/detail'], () => resolve(require('../pages/application/detail')), 'applicationDetail')
const menuSet = resolve => require.ensure(['../pages/menu-set'], () => resolve(require('../pages/menu-set')), 'menuSet')
import bomBill from '../pages/bom-bill' // 模拟生产
import simulationProduce from '../pages/simulation-produce' // 模拟生产
import productionOrder from '../pages/production-order' // 生产单
// const businessCase = () => import(/* webpackChunkName: "industryTemplete" */ '../pages/application/business-case') // 行业模板
const templatePreview = () => import(/* webpackChunkName: "industryTemplete" */ '../pages/application/template-preview') // 行业模板
// const industryTemplete = () => import(/* webpackChunkName: "industryTemplete" */ '../pages/application/industry-templete') // 行业模板

Vue.use(Router)

export default new Router({

  routes: [{
    path: '/',
    component: Home
  },
  {
    path: '/supplier',
    component: supplier
  },
  {
    name: 'purchase',
    path: '/purchase',
    component: purchase
  },
  {
    name: 'returnedPurchase',
    path: '/returnedPurchase',
    component: returnedPurchase
  },
  {
    name: 'transfer',
    path: '/transfer',
    component: transfer
  },
  {
    name: 'inventory',
    path: '/inventory',
    component: inventory
  },
  {
    name: 'instock',
    path: '/instock',
    component: instock
  },
  {
    name: 'outstock',
    path: '/outstock',
    component: outstock
  },
  {
    path: '/productStock',
    component: productStock
  },
  {
    path: '/payPlan',
    component: payPlan
  },
  {
    path: '/customer',
    component: customer
  },
  {
    path: '/customer/isNearby',
    component: customerNearby
  },
  {
    path: '/customer/:child',
    component: customer
  },
  {
    path: '/strategy/setup',
    component: strategySetup
  },
  {
    path: '/communicatePlan',
    component: communicatePlan
  },
  {
    path: '/opportunity',
    component: opportunity
  },
  {
    path: '/opportunity/:child',
    component: opportunity
  },
  {
    path: '/contract',
    component: contract
  },
  {
    path: '/contact',
    component: contact
  },
  {
    path: '/payment',
    component: payment
  },
  {
    path: '/communicate',
    component: communicate
  },
  {
    path: '/targetThrough/customer',
    component: targetCustomer
  },
  {
    path: '/targetThrough/opportunity',
    component: targetOpportunity
  },
  {
    path: '/targetThrough/contract',
    component: targetContract
  },
  {
    path: '/targetThrough/communicate',
    component: targetCommunicate
  },
  {
    path: '/targetThrough/productContract',
    component: targetProductContract
  },
  {
    path: '/targetThrough/contact',
    component: targetContact
  },
  {
    path: '/targetThrough/paymentUn',
    component: targetPaymentUn
  },
  {
    path: '/targetThrough/paymentEd',
    component: targetPaymentEd
  },
  {
    path: '/targetThrough/payPlanUn',
    component: targetPayPlanUn
  },
  {
    path: '/targetThrough/payPlanEd',
    component: targetPayPlanEd
  },
  {
    path: '/targetThrough/purchase',
    component: targetPurchase
  },
  {
    path: '/targetThrough/invoiceEd',
    component: targetInvoiceEd
  },
  {
    path: '/targetThrough/redRefundReason',
    component: targetRefund
  },
  {
    path: '/targetThrough/workOrder',
    component: targetWorkOrder
  },
  {
    path: '/targetThrough/workflow4Order',
    component: targetWorkflow4Order
  },
  {
    path: '/targetThrough/workflow4Degree',
    component: targetWorkflow4Degree
  },
  {
    path: '/targetThrough/productionOrder',
    component: targetProductionOrder
  },
  {
    path: '/workReport',
    component: workReport
  },
  {
    path: '/workReport/statistical',
    component: workStatistical
  },
  {
    path: '/workReport/setup',
    component: workSetup
  },
  {
    path: '/message/page', // 消息提醒筛选页
    component: messagePage
  },
  {
    path: '/message/statistical',
    component: messageStatistical
  },
  {
    path: '/message/pushSetting', // 消息推送设置
    component: messagePushSet
  },

  /* --业绩目标开始-- */
  {
    path: '/performance',
    name: 'performanceIndex',
    component: managementByObjective,
    meta: {
      pathName: '目标管理'
    },
    children: [
      {
        path: 'indexSetting',
        name: 'performanceIndexSetting',
        component: performanceObjectiveIndexSetting, // 指标值设置
        meta: {
          pathName: '指标值设置'
        }
      },
      {
        path: 'valueSetting',
        name: 'performanceValueSetting',
        component: performanceObjectiveValueSetting, // 目标值设置
        meta: {
          pathName: '目标值设置'
        }
      },
      {
        path: 'paramSetting',
        name: 'performanceParamSetting',
        component: performanceObjectiveParamSetting, // 目标值设置
        meta: {
          pathName: '参数设置'
        }
      },
      {
        path: 'import',
        name: 'performanceImport',
        component: performanceObjectiveImport, // 目标导入
        meta: {
          pathName: '目标导入'
        }
      }
    ]
  },

  // 目标完成情况
  {
    path: '/completion',
    name: 'completionIndex',
    component: performanceCompletion
  },

  {
    path: '/signInManage',
    component: signInManage
  },
  {
    path: '/signInStatistic',
    component: signInStatistic
  },
  {
    name: 'assemble',
    path: '/assemble',
    component: assemble
  },
  {
    path: '/bi/list',
    component: biList
  },
  {
    path: '/bi/set',
    component: biSet
  },
  {
    path: '/bi/add',
    component: biAdd
  },
  {
    path: '/invoice',
    component: invoice
  },
  {
    path: '/approvalSet',
    component: approvalSet
  },
  {
    path: '/approval',
    component: approval
  },
  {
    path: '/publicRuleSet',
    component: publicRuleSetup
  },
  {
    path: '/publicGroupSet',
    component: publicCustomerSetup
  },
  {
    path: '/salesReport',
    component: salesReport
  },
  {
    name: 'jxcAddPage',
    path: '/jxcAddPage',
    component: jxcAddPage
  },
  {
    name: 'productApi',
    path: '/productList',
    component: productList
  },
  {
    name: 'waitPurchaseApi',
    path: '/wForPurchase',
    component: wForPurchase
  },
  {
    name: 'waitInstockPurchase',
    path: '/waitInstock',
    component: waitInstock
  },
  {
    name: 'waitOutstock',
    path: '/waitOutstock',
    component: waitOutstock
  },
  {
    name: 'waitProduce',
    path: '/waitProduce',
    component: waitProduce
  },
  {
    path: '/simulationProduce',
    component: simulationProduce
  },
  {
    name: 'bomBill',
    path: '/bomBill',
    component: bomBill
  },
  {
    name: 'productionOrder',
    path: '/productionOrder',
    component: productionOrder
  },
  {
    path: '/workOrder',
    component: workOrder
  },
  {
    path: '/workOrder/managerIndex',
    component: workOrderManager
  },
  {
    path: '/workOrder/pendingOrder',
    component: workOrderPendingOrder
  },
  {
    path: '/workOrder/serviceStaff',
    component: serviceStaff
  },
  {
    path: '/callCenter/agent',
    component: Agent
  },
  {
    path: '/callCenter/calllog',
    component: CallLog
  },
  {
    path: '/callCenter/setting',
    component: Setting
  },
  {
    path: '/callCenter/teamdata',
    component: Teamdata
  },
  {

    path: '/print/index',
    component: Print
  },
  {
    path: '/application/list',
    component: applicationList,
    name: 'applicationHome'
  },
  // {
  //   path: '/application/industryTemplete',
  //   component: industryTemplete
  // },
  { // 模块设置首页
    path: '/application',
    component: application,
    name: 'applicationHomeNew',
    children: [
      // { // 行业案例
      //   path: '/businessCase',
      //   component: businessCase,
      //   name: 'businessCase',
      //   meta: {
      //     title: '行业案例'
      //   }
      // },
      { // 行业样板预览
        path: '/templatePreview',
        component: templatePreview,
        name: 'industryTemplatePreview',
        meta: {
          title: '行业样板预览'
        }
      }
    ]
  },
  {
    path: '/application/detail',
    component: applicationDetail
  },
  {
    path: '/menuSet',
    component: menuSet
  }
  ]
})



// WEBPACK FOOTER //
// ./src/config/router.js